import { render, staticRenderFns } from "./setindex.vue?vue&type=template&id=6bb5113a&scoped=true"
import script from "./setindex.vue?vue&type=script&lang=js"
export * from "./setindex.vue?vue&type=script&lang=js"
import style0 from "./setindex.vue?vue&type=style&index=0&id=6bb5113a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb5113a",
  null
  
)

export default component.exports